// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1Ltdc","modalFooterButton":"ModalNotes_modalFooterButton__2qSrX"};